module.exports = __webpack_public_path__ + "static/media/LogoSemFundo.736afa62.png";